export default __webpack_public_path__ + "static/media/revoptimal_logo_medium_res.2e3e98ba.png";